import React from 'react'
import Highcharts from 'highcharts'
import HighchartsWrapper from './HighChartsWrapper'
import { LineChartCardProps } from '../../utils'

const LineChartCard: React.FC<LineChartCardProps> = ({
  categories,
  series,
  xAxisTitle = '',
  yAxisTitle = '',
}) => {
  const chartOptions: Highcharts.Options = {
    chart: {
      type: 'line',
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories,
      title: {
        text: xAxisTitle,
        style: {
          fontWeight: '500',
          color: 'var(--accent-900)',
          fontSize: '18px',
        },
        margin: 30,
      },
      tickmarkPlacement: 'on',
      tickLength: 12,
      tickWidth: 1,
      tickColor: 'var(--accent-900)',
      lineWidth: 1,
      lineColor: 'var(--accent-900)',
      crosshair: {
        color: 'var(--accent-900)',
        width: 1,
        dashStyle: 'Dash',
      },
      labels: {
        style: {
          color: 'var(--accent-900)',
          fontSize: '14px',
          fontWeight: '300',
        },
      },
    },
    yAxis: {
      title: {
        text: yAxisTitle,
        style: {
          fontWeight: '500',
          color: 'var(--accent-900)',
          fontSize: '18px',
        },
        margin: 20,
      },
      gridLineColor: 'var(--accent-100)',
      labels: {
        style: {
          color: 'var(--accent-900)',
          fontSize: '14px',
          fontWeight: '300',
        },
      },
    },
    legend: {
      align: 'right',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemStyle: { color: 'var(--accent-900)', fontWeight: '500' },
    },
    plotOptions: {
      line: {
        marker: {
          enabled: true,
          radius: 4,
          symbol: 'circle',
        },
        lineWidth: 2,
      },
    },
    series: series.map((s) => ({
      ...s,
      type: 'line',
      marker: { enabled: true },
    })),
    credits: {
      enabled: false,
    },
  }

  return (
    <HighchartsWrapper
      options={chartOptions}
      containerProps={{ className: 'h-fit w-full' }}
    />
  )
}

export default LineChartCard
